import { useState, useEffect } from 'react';
import { statsData } from '@/mocks/sportsData';

export default function StatsSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="py-14 md:py-20 bg-accent-500 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0.1)_0%,transparent_70%)]"></div>
      <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-2">
            平台数据一览
          </h2>
          <p className="text-sm text-background-100/80">专业数据，值得信赖</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {statsData.map((stat, index) => (
            <div
              key={stat.label}
              className={`bg-background-50/15 backdrop-blur-sm rounded-lg p-5 md:p-6 text-center transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                <i className={`${stat.icon} text-3xl text-background-50`}></i>
              </div>
              <div className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-background-100/90 mb-2">{stat.label}</div>
              <div className="text-xs text-background-100/70 flex items-center justify-center gap-1">
                <i className="ri-arrow-up-line text-secondary-300"></i>
                <span>{stat.change} 同比增长</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}